import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormCurrencyField, FormSwitch, FormTextField } from '../../lib/components';
import { BenefitIcon, BenefitKey } from '../../lib/components/compound/dataDisplay';

interface Props {
  benefitKey: BenefitKey;
  max?: number;
}

export const BenefitRow: FC<Props> = ({ benefitKey, max }) => {
  const { t } = useTranslation('benefits');

  return (
    <Grid item xs={6}>
      <Grid container>
        <Grid item display="flex" xs={6}>
          <BenefitIcon benefitKey={benefitKey} size={36} sx={{ marginRight: '14px' }} />
          <Box>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                lineHeight: '18px'
              }}
            >
              {t(benefitKey)}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                color: 'grey.900',
                lineHeight: '18px'
              }}
            >
              {t(benefitKey, { context: 'subtitle' })}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={4} paddingLeft="1.5rem">
          {benefitKey !== 'fahrtkosten' ? (
            <FormCurrencyField
              numberInputProps={{
                isAllowed: (input) => {
                  const { floatValue } = input;
                  if (floatValue && max) {
                    return floatValue >= 0 && floatValue <= max;
                  }
                  return true;
                }
              }}
              name={`${benefitKey}_amount`}
            />
          ) : (
            <FormTextField
              type="number"
              placeholder={'0,00'}
              endAdornment="km"
              name={`${benefitKey}_amount`}
            />
          )}
        </Grid>
        <Grid item xs={1} paddingLeft=".5rem">
          <FormSwitch name={`${benefitKey}_enabled`} />
        </Grid>
      </Grid>
    </Grid>
  );
};
